import React from "react";
import { Link } from "react-router-dom";
import { formatInsightDate } from "./insight-utils";

const InsightCard = ({ post, showDate = true, showTags = true }) => {
  if (!post) return null;

  return (
    <article className="insight-card insight-card--listing">
      <div className="insight-card-body">
        <span className="insight-card-tag">{post.category}</span>
        <h3>{post.title}</h3>
        <p>{post.excerpt}</p>
        <div className="insight-card-meta">
          {showDate && <span>{formatInsightDate(post.publishDate)}</span>}
          <span>{post.readingTime}</span>
        </div>
        {showTags && post.tags?.length ? (
          <div className="insight-card-tags">
            {post.tags.slice(0, 3).map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        ) : null}
        <Link to={`/blog/${post.slug}`} className="insight-card-link">
          Read More →
        </Link>
      </div>
    </article>
  );
};

export default InsightCard;

